stimulusApp.register(
  "transfer-passengers",
  class extends Stimulus.Controller {
    static targets = ["fullName", "passportNumber", "copyButton"]
    static outlets = ["transfer-passengers"]

    transferPassengersOutletConnected() {
      this.copyButtonTarget.classList.remove("hidden")
    }

    copyFromArrival() {
      const source = this.transferPassengersOutlet
      this.#copyValues(source.fullNameTargets, this.fullNameTargets)
      this.#copyValues(source.passportNumberTargets, this.passportNumberTargets)
    }

    #copyValues(sourceInputs, destinationInputs) {
      destinationInputs.forEach((input, index) => {
        const sourceInput = sourceInputs[index]
        if (sourceInput) input.value = sourceInput.value
      })
    }
  },
)
